import React, { Component } from 'react';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import { getFormValues, getFormSyncErrors, isDirty, SubmissionError } from 'redux-form';
import { bindActionCreators } from 'redux';

import AuthService from '../../services/api/auth';
import * as registerActions from './actions/';
import PersonalDetailsForm from '../../components/PersonalDetailsForm';
import LoadingModal from '../../components/LoadingModal';
import { dateIsValid, required } from '../../inputs/validations';
import Helper from '../../helpers';

class PersonalDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            errors: {},
            promocode: '',
            promocodeError: '',
            lowIncome: false,
            lowIncomeError: '',
        };
    }

    // promises
    savePersonalDetails = data =>
        new Promise((resolve, reject) =>
            AuthService.savePersonalDetails(data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error))
        );

    submitPromocode = promocode =>
        new Promise((resolve, reject) => {
            return AuthService.submitPromocode(promocode)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });

    goToNextPage = () =>
        AuthService.getAccountStatus().then(response => {
            if (response.next === null) {
                this.props.history.push('/status');
            } else {
                this.props.history.push(response.next);
            }
        });

    onSubmit(data) {
        const { promocodeError, lowIncomeError } = this.state;
        if (promocodeError) {
            this.setState({ promocodeError: '' });
        }
        if (lowIncomeError) {
            this.setState({ lowIncomeError: '' });
        }
        let validationMapping =
            window.VULOG_CONFIG.STEPS.map(i => i.title).indexOf('DL_CHECK') === -1
                ? {
                      BirthDate: [dateIsValid],
                  }
                : {};

        if (window.VULOG_CONFIG.REQUIRED_PERSONAL_DETAILS_FIELDS) {
            let requiredFields = window.VULOG_CONFIG.REQUIRED_PERSONAL_DETAILS_FIELDS;

            // if the DL is present in the steps, remove this fields from validation in personal details
            const DLfields = ['GivenName', 'Surname', 'BirthDate'];
            if (window.VULOG_CONFIG.STEPS.map(i => i.title).indexOf('DL_CHECK') !== -1) {
                requiredFields = requiredFields.filter(field => !DLfields.includes(field));
            }

            requiredFields.forEach(field => {
                if (validationMapping[field] && !validationMapping[field].includes(required)) {
                    validationMapping[field].push(required);
                } else {
                    validationMapping[field] = [required];
                }
            });
        }

        return new Promise((resolve, cancel) => {
            let errors = {};

            Object.keys(validationMapping).forEach(key => {
                validationMapping[key].forEach(func => {
                    const message = func(data[key], data);
                    if (message) {
                        errors[key] = message;
                    }
                });
            });
            resolve(errors);
        })
            .then(errors => {
                if (Object.keys(errors).length > 0) {
                    this.setState({
                        errors,
                    });
                    throw new SubmissionError(errors);
                }

                this.setState({
                    loading: true,
                });
            })
            .then(() => {
                const { promocode, lowIncome } = this.state;
                let promises = [this.savePersonalDetails(data).catch(error => error)];
                if (promocode) {
                    promises = [...promises, this.submitPromocode(promocode).catch(error => error)];
                }
                if (
                    window.VULOG_CONFIG.LOW_INCOME &&
                    window.VULOG_CONFIG.LOW_INCOME_PROMO_CODE &&
                    lowIncome &&
                    this.props.initialValues.hasLowIncome !== 1 &&
                    !this.props.initialValues.isBusiness
                ) {
                    promises = [
                        ...promises,
                        this.submitPromocode(window.VULOG_CONFIG.LOW_INCOME_PROMO_CODE).catch(error => error),
                    ];
                }
                return Promise.all(promises)
                    .then(val => {
                        this.setState({
                            loading: false,
                        });

                        // All promises return success, we continue
                        if (val.every(resp => resp.success)) {
                            return this.goToNextPage();
                        }

                        if (val.length === 3) {
                            // we have either promocode and low income
                            if (!val[1].success) {
                                this.setState({ promocodeError: 'This promocode is invalid' });
                            }
                            if (!val[2].success) {
                                this.setState({ lowIncomeError: 'This low income code is invalid' });
                            }
                        }

                        if (val.length === 2) {
                            if (!val[1].success && promocode) {
                                this.setState({ promocodeError: 'This promocode is invalid' });
                            }
                            if (!val[1].success && lowIncome) {
                                this.setState({ lowIncomeError: 'low_income_error' });
                            }
                        }
                    })
                    .catch(e => {
                        this.setState({
                            loading: false,
                        });

                        if (e && e.data && e.data.message) {
                            throw new SubmissionError({
                                _error: e.data.message,
                            });
                        }
                    });
            });
    }

    cancel() {
        AuthService.getAccountStatus().then(response => {
            response.steps.forEach((entry, i) => {
                if (entry.path === this.props.location.pathname) {
                    if (entry.back) {
                        this.props.history.push(entry.back);
                    } else {
                        const lastScreen = response.steps[i - 1];
                        if (lastScreen && lastScreen.path) {
                            this.props.history.push(lastScreen.path);
                        }
                    }
                }
            });
        });
    }

    componentDidMount() {
        this.props.setStep('PD');
        AuthService.getPersonalDetails()
            .then(response => {
                const { Country: previousCountry } = response;
                let countryValue = '';
                if (!Helper.isFieldRequired('Country') && previousCountry) {
                    countryValue = previousCountry;
                }
                const newResponse = { ...response, Country: countryValue };
                this.props.populateForm(newResponse, 'personalDetails');
                this.setState({
                    loading: false,
                });
            })
            .catch(() => {
                this.setState({
                    loading: false,
                    errors: ['DEFAULT_ERROR_MESSAGE'],
                });
            });
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.lowIncome && this.props.initialValues.hasLowIncome === 1) {
            this.setState({ lowIncome: true });
        }
    }

    render() {
        const { promocodeError, lowIncome, lowIncomeError } = this.state;
        return (
            <div className="container-fluid wrapper">
                <div className="d-flex flex-column full-height menu-bar-bottom">
                    <h3 className="page__title">{window.VULOG_TRANSLATE('PERSONAL DETAILS')}</h3>

                    <div className="f-container flex-grow-1">
                        <PersonalDetailsForm
                            errors={{ ...this.props.submitErrors, ...this.state.errors }}
                            {...this.props}
                            ref={ref => {
                                this._form = ref;
                            }}
                            onSubmit={this.onSubmit.bind(this)}
                        />
                    </div>

                    {window.VULOG_CONFIG &&
                        window.VULOG_CONFIG.ENABLE_PROMOCODE &&
                        !window.VULOG_CONFIG.STEPS.map(step => step.screen).includes('PROMOCODE') && (
                            <React.Fragment>
                                <p>{window.VULOG_TRANSLATE('Set a promocode')}</p>
                                {promocodeError && <p className={'form__errors danger'}>{promocodeError}</p>}
                                <div className="form-row mb-4">
                                    <label htmlFor="promo-code" className="blue small col-4 mb-0">
                                        {window.VULOG_TRANSLATE('Promo Code')}
                                    </label>
                                    <div className="col">
                                        <input
                                            name={'promo-code'}
                                            value={this.state.promocode}
                                            onChange={e => {
                                                this.setState({
                                                    promocode: e.target.value,
                                                });
                                            }}
                                            type="text"
                                            className="form-control"
                                            id="promo-code"
                                            disabled={!!this.state.next}
                                        />
                                    </div>
                                </div>
                            </React.Fragment>
                        )}

                    {window.VULOG_CONFIG.LOW_INCOME &&
                        window.VULOG_CONFIG.LOW_INCOME_PROMO_CODE &&
                        !this.props.initialValues.isBusiness && (
                            <React.Fragment>
                                <div className="form-row mb-4">
                                    <input
                                        type="checkbox"
                                        name={'low_income'}
                                        className="form-check-input custom-checkbox"
                                        id="low_income"
                                        disabled={this.props.initialValues.hasLowIncome}
                                        checked={lowIncome}
                                        value={lowIncome}
                                        onChange={() => this.setState({ lowIncome: !lowIncome })}
                                    />
                                    <label htmlFor="low_income">
                                        {window.VULOG_TRANSLATE('low_income')}
                                        <br />
                                        {window.VULOG_CONFIG.LOW_INCOME_LINK && (
                                            <a className={'ml-0'} href={window.VULOG_CONFIG.LOW_INCOME_LINK}>
                                                {window.VULOG_TRANSLATE('low_income_link')}
                                            </a>
                                        )}
                                    </label>
                                </div>
                                {lowIncomeError && (
                                    <p className={'form__errors danger'}>
                                        {window.VULOG_TRANSLATE(['low_income_error'])}
                                    </p>
                                )}
                            </React.Fragment>
                        )}

                    <div className="d-flex flex-row mt-auto mb-1-5rem">
                        {this.props.position !== window.VULOG_CONFIG.STEPS[1].screen ? (
                            <button onClick={() => this.cancel()} className="btn btn-primary btn-block">
                                <i className="material-icons va-middle reg">keyboard_arrow_left</i>
                                {window.VULOG_TRANSLATE('Back')}
                            </button>
                        ) : null}
                        <button className="btn btn-primary btn-block" onClick={() => this._form.submit()}>
                            {window.VULOG_TRANSLATE('Next')}
                            <i className="material-icons va-middle reg">keyboard_arrow_right</i>
                        </button>
                    </div>
                    <LoadingModal loading={this.state.loading} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        personalDetails: state.register.personalDetails,
        initialValues: state.register.personalDetails,
        enableReinitialize: true,
        formValues: getFormValues('personal-details')(state),
        submitErrors: getFormSyncErrors('personal-details')(state),
        isDirty: isDirty('personal-details')(state),
        position: state.register.position,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(registerActions, dispatch);
}

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(PersonalDetails));
